import { ImageUrlCellParams } from 'types/aiIllustration';

export function pngImageRenderer(params: ImageUrlCellParams): string {
  if (!params.value) {
    return '';
  }

  const imageUrl = params.value;

  return `<div style="display: flex; align-items: center; justify-content: center; padding: 4px; height: 200px; width: 100%;">
    <img src="${imageUrl}"
         style="max-width: 250px; max-height: 190px; width: auto; height: auto; object-fit: contain;"
         alt="PNG Image"
         onerror="this.style.display='none'; this.parentElement.innerHTML='<span style=\\'color: #999;\\'>Image not found</span>';"
    />
  </div>`;
}
